module.exports = __webpack_public_path__ + "img/mobile-app-store.d0558d91.svg";